module.exports = __webpack_public_path__ + "img/new_icon1.42c84ce3.png";